export default {"src":"/_next/static/image/public/images/flags/flag_683.cd07614a4c44e4680ea306cc82f12b3b.svg","height":16,"width":24};